import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = "vemoye_admin_token";
const MEMBER_TOKEN_KEY = "vemoye_member_token";

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);
export const setAdminToken = (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);

export const getMemberToken = () => localStorage.getItem(MEMBER_TOKEN_KEY);
export const setMemberToken = (t) => localStorage.setItem(MEMBER_TOKEN_KEY, t);
export const clearMemberToken = () => localStorage.removeItem(MEMBER_TOKEN_KEY);

// Backward compatibility with older admin pages
export const getToken = getAdminToken;
export const setToken = setAdminToken;
export const clearToken = clearAdminToken;

const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = getAdminToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const memberApi = axios.create({ baseURL: API });
memberApi.interceptors.request.use((cfg) => {
  const t = getMemberToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const publicApi = axios.create({ baseURL: API });

export const api = adminApi; // default admin (existing usages)
export { adminApi, memberApi, publicApi };
